import * as React from 'react';
const SvgCrossIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={17} fill="none" {...props}>
    <path
   
      fill="currentColor"
      d="m10.408 8.159 6.3-6.29a1.004 1.004 0 1 0-1.42-1.42l-6.29 6.3-6.29-6.3a1.004 1.004 0 0 0-1.42 1.42l6.3 6.29-6.3 6.29a1 1 0 0 0 0 1.42.998.998 0 0 0 1.42 0l6.29-6.3 6.29 6.3a.997.997 0 0 0 1.095.218.999.999 0 0 0 .325-.218 1 1 0 0 0 0-1.42l-6.3-6.29Z"
    />
  </svg>
);
export default SvgCrossIcon;
